import { useCallback, useMemo } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/auth/useAuth';
import { useActiveOrgSlug } from '@/lib/useOrgRoutes';
import { ROUTES } from '@/lib/routes';
import { useNavSources } from '../NavBar/useNavSources';
import { ConnectShellView } from './ConnectShellView';
import { useTakeoverEscape } from './useTakeoverEscape';
import { buildConnectNav } from './connect-nav';

/**
 * Layout route for the Connect takeover: Credentials, Sharing, MCP,
 * AI Gateway, and Integrations render inside this shell. Back and `esc`
 * always return to the org's agent sessions page.
 */
export function ConnectShell() {
  const slug = useActiveOrgSlug();
  const { activeMembership } = useAuth();
  const { configureDrillGroups } = useNavSources();
  const navigate = useNavigate();
  const location = useLocation();

  const connectItems = useMemo(
    () => buildConnectNav(slug, configureDrillGroups),
    [slug, configureDrillGroups],
  );

  const goBack = useCallback(() => {
    const fallback = slug ? ROUTES.org(slug).runs : ROUTES.root;
    void navigate(fallback);
  }, [navigate, slug]);

  useTakeoverEscape(goBack, true);

  return (
    <ConnectShellView
      orgName={activeMembership?.organization.name ?? 'Organization'}
      activePath={location.pathname}
      items={connectItems}
      onBack={goBack}
    >
      <Outlet />
    </ConnectShellView>
  );
}
